<app-header/>

<div class="polls" *ngIf="pollsData">
  <div class="wrapper">
    <p>{{pollsData.question}}</p>
    <div class="answers">
      <ng-container *ngFor="let value of pollsData.value; let i = index;">
        <div *ngIf="value != ''">
          <input (change)="pollChecked(i + 1, pollsData.id)" [disabled]="isAnswering" type="checkbox" name="answer-{{i+1}}" value="{{i+1}}" id="answer-{{i+1}}">
          <label for="answer-{{i+1}}">{{value}}</label>
        </div>
      </ng-container>
    </div>
  </div>
</div>
